import ApolloClient from "apollo-client";
import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import fetch from "unfetch";

import { navigate } from "svelte-routing";
import { authToken } from "./stores.js";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message }) => {
      if (message === "unauthorized") {
        console.log("Auth problem");
        localStorage.removeItem("user-token");
        authToken.set(null);
        navigate("/", { replace: true });
      } else {
        console.error(graphQLErrors);
      }
    });
  }
  if (networkError) {
    // danger(`Connections problem:\n${networkError.toString()}`);
    console.log("Network error");
  }
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("user-token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const cache = new InMemoryCache();

const httpLink = new HttpLink({
  uri: "/api/graphql",
  headers: { "content-type": "application/json" },
  fetch: fetch,
});

export const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache,
});
